import React from 'react';
import { func, node, oneOf, string } from 'prop-types';
import classNames from 'classnames';
import { HiOutlineCheckCircle, HiOutlineClock, HiOutlineXCircle } from 'react-icons/hi2';
import { FormattedMessage } from '../../util/reactIntl';
import { InlineTextButton } from '../../components';

import css from './InvoicingStatusBox.css';

// Tells a customer where their invoicing stands: approved, under review or
// not granted. Same icon/colour language as the request modal's outcome view
// (TransactionPanel.css requestInvoicingStatus*). The caller passes the copy;
// the box owns the status colouring and the optional support link.
const ICONS = {
  approved: HiOutlineCheckCircle,
  pending: HiOutlineClock,
  denied: HiOutlineXCircle,
};

const InvoicingStatusBox = props => {
  const { className, status, title, text, children, onContactSupport } = props;
  const Icon = ICONS[status] || ICONS.approved;

  return (
    <div className={classNames(css.box, css[status], className)} role="status" data-status={status}>
      <Icon className={css.icon} aria-hidden="true" />
      <div className={css.textWrapper}>
        <div className={css.title}>{title}</div>
        {text ? <div className={css.text}>{text}</div> : null}
        {children}
        {onContactSupport ? (
          <InlineTextButton className={css.supportButton} type="button" onClick={onContactSupport}>
            <FormattedMessage id="InvoicingStatusBox.contactSupport" />
          </InlineTextButton>
        ) : null}
      </div>
    </div>
  );
};

InvoicingStatusBox.defaultProps = {
  className: null,
  status: 'approved',
  text: null,
  children: null,
  onContactSupport: null,
};

InvoicingStatusBox.propTypes = {
  className: string,
  status: oneOf(['approved', 'pending', 'denied']),
  title: node.isRequired,
  text: node,
  children: node,
  onContactSupport: func,
};

export default InvoicingStatusBox;
